<div class="flex flex-col h-[100%] bg-gray-50">
    <div class="flex justify-center py-[77px] px-[60px]">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7">
            <div *ngIf="rootScope.invoiceExtractVisible()" class="h-[271px] bg-white rounded-[8px] shadow-md px-6 gap flex flex-col items-center hover:shadow-lg transition-shadow">
                    <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/home-invoice-icon.svg' alt="Invoice Extract"></span>
                <div class="text-base font-medium #2C2C2C mb-4">Invoice Extract</div>
                <div class="text-[16px] font-medium #000000CC text-center mb-4">Search Invoices and Download as needed.</div>
                <button routerLink="/fileGrid" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>

            <div *ngIf="rootScope.cbemVisible()" class="h-[271px] bg-white rounded-xl shadow-md px-6 flex flex-col items-center hover:shadow-lg transition-shadow">
                    <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/home-cbem-icon.svg' alt="CBEM"></span>
                <div class="text-base font-medium #2C2C2C mb-4">CBEM</div>
                <div class="text-[16px] font-medium #000000CC text-center mb-4">View and Manage Customer Billing and Escalation Master</div>
                <button routerLink="/CBEM" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>
            <div *ngIf="rootScope.masterClientVisible()" class="h-[271px] bg-white rounded-xl shadow-md px-6 flex flex-col items-center hover:shadow-lg transition-shadow">
                <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/home-masterclientdb-icon.svg' alt="Master Client Database"></span>
                <div class="text-base font-medium #2C2C2C mb-4">Master Client Database</div>
                <div class="text-[16px] font-medium #000000CC text-center mb-4">View and Manage Client info and products they use</div>
                <button routerLink="/ClientNav" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>
            <div *ngIf="rootScope.referralVisible()" class="h-[271px] bg-white rounded-xl shadow-md px-6 flex flex-col items-center hover:shadow-lg transition-shadow">
                <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/badge-check-svgrepo-com.svg' alt="GB Referrals"></span>
                <div class="text-base font-medium #2C2C2C mb-4">GB Referrals</div>
                <button routerLink="/Referrals" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>
            <div *ngIf="rootScope.dynamoUtilityVisible()" class="h-[271px] bg-white rounded-xl shadow-md px-6 flex flex-col items-center hover:shadow-lg transition-shadow">
                <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/home-dynamo-utility-icon.svg' alt="DynamoDB Utility"></span>
                <div class="text-base font-medium #2C2C2C mb-4">DynamoDB Utility</div>
                <div class="text-[16px] font-medium #000000CC text-center mb-4">Insert, update or delete table entries using DynamoDB JSON</div>
                <button routerLink="/DynamoUtility" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>


            <div class="md:col-start-2 h-[271px] bg-white rounded-xl shadow-md px-6 flex flex-col items-center hover:shadow-lg transition-shadow">
            <span class="w-12 h-12 mt-10 mb-4"><img src='assets/logos/home-customer-support-icon.svg' alt="Support"></span>
                <div class="text-base font-medium #2C2C2C mb-4">Support</div>
                <div class="text-[16px] font-medium #000000CC text-center mb-4">Who you can reach out for help and Support</div>
                <button (click)="openSupportModal()" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-[#FFFFFF] cursor-pointer">Explore</button>
            </div>
        </div>
    </div>
</div>

<!-- Support Help Modal -->
<div *ngIf="supportModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div class="bg-white rounded-[8px] shadow-2xl w-[500px] max-w-[90%] p-6 relative">
        <!-- Logo -->
        <div class="mb-6">
            <img src="assets/logos/Verisk-colored-logo.jpg" alt="Verisk" class="h-10">
        </div>

        <!-- Title -->
        <h2 class="text-xl font-semibold text-[#1a1a1a] mb-2">Help and Assistance</h2>
        <p class="text-sm text-[#555] mb-5">Select a product to view its support contact details:</p>

        <!-- Custom Dropdown -->
        <div class="relative mb-6" data-dropdown-scope="true">
            <input
                type="text"
                readonly
                class="w-full border rounded px-3 pr-10 py-3 text-sm font-light focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white cursor-pointer"
                [value]="selectedTile || ''"
                (click)="tileDropdownOpen = !tileDropdownOpen"
                placeholder=" "
            />
            <span class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
                <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M7 10h10l-5 6z"></path>
                </svg>
            </span>
            <label
                class="absolute left-3 px-1 pointer-events-none"
                [ngClass]="{
                    '-top-2 text-xs text-gray-600 bg-white shadow-sm': selectedTile,
                    'top-3 text-sm text-gray-500 bg-transparent': !selectedTile
                }"
            >
                Select a product
            </label>

            <div
                *ngIf="tileDropdownOpen"
                class="absolute mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto"
                style="z-index: 1000;"
            >
                <button
                    type="button"
                    *ngFor="let contact of supportContacts"
                    (mousedown)="$event.preventDefault(); selectTileFromDropdown(contact.tileName)"
                    class="w-full px-3 py-2 text-sm text-left cursor-pointer select-none hover:bg-blue-50"
                >
                    {{ contact.tileName }}
                </button>
            </div>
        </div>

        <!-- Contact Details -->
        <div *ngIf="selectedContact" class="space-y-4 mb-6">
            <p class="text-sm text-[#555]">Please contact the {{ selectedContact.tileName }} Support Desk on:</p>
            <div *ngIf="selectedContact.phone?.trim()" class="flex items-center gap-3">
                <svg class="w-5 h-5 text-[#00358E] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.01-.24c1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.07 21 3 13.93 3 4c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.1.31.03.66-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span class="text-base font-medium">{{ selectedContact.phone }}</span>
            </div>
            <div *ngIf="selectedContact.email?.trim()" class="flex items-center gap-3">
                <svg class="w-5 h-5 text-[#00358E] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <a [href]="'mailto:' + selectedContact.email" class="text-base font-medium text-[#00358E] underline">{{ selectedContact.email }}</a>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex justify-end">
            <button (click)="closeSupportModal()" class="px-6 py-[10px] bg-[#00358E] rounded-[44px] text-base font-medium text-white cursor-pointer">
                Close
            </button>
        </div>
    </div>
</div>
